import {
  REPORT_TYPES,
  createNavigationListener,
  navigate,
  report,
} from '@adsk/exo-skeleton-api';
import isExoRoute from './isExoRoute';
import safeGetPathname from './safeGetPathname';

declare global {
  interface Window {
    exoNavigate: (to: string) => void;
    [key: string | number | symbol]: unknown;
  }

  interface WindowEventMap {
    'exo-skeleton:navigate': CustomEvent;
  }
}

export function initializeNavigationHandler() {
  /**
   * @deprecated Please use "navigate" function from "@adsk/exo-skeleton-api" instead.
   */
  window.exoNavigate = (to: string) => {
    void report({
      type: REPORT_TYPES.warning,
      value: `window.exoNavigate is deprecated, please use navigate('...') instead from '@adsk/exo-skeleton-api'`,
      context: {
        to,
      },
    });

    return navigate(to);
  };

  return createNavigationListener({
    onNavigate({ data: { to } }) {
      const isNavigatingToExoRoute = isExoRoute(to);

      if (isNavigatingToExoRoute) {
        const detail = safeGetPathname(to);
        const navigationEvent = new CustomEvent('exo-skeleton:navigate', {
          detail,
        });

        window.dispatchEvent(navigationEvent);
      } else {
        window.location.assign(to);
      }
    },
  });
}
